import React from 'react';
import type { PasswordRequirements } from '../utils/passwordValidation';
import { SPECIAL_CHARS_LIST } from '../utils/passwordValidation';
import './PasswordRequirements.css';

interface PasswordRequirementsProps {
  requirements: PasswordRequirements;
  passwordsMatch: boolean;
  showMatchRequirement?: boolean;
}

const PasswordRequirementsComponent: React.FC<PasswordRequirementsProps> = ({
  requirements,
  passwordsMatch,
  showMatchRequirement = true,
}) => {
  return (
    <ul className="password-requirements-list">
      <li className={`requirement-item ${requirements.hasNumber ? 'met' : 'unmet'}`}>
        <span className="requirement-icon">{requirements.hasNumber ? '✓' : '○'}</span>
        <span className="requirement-text">Al menos 1 número</span>
      </li>
      <li className={`requirement-item ${requirements.hasSpecialChar ? 'met' : 'unmet'}`}>
        <span className="requirement-icon">{requirements.hasSpecialChar ? '✓' : '○'}</span>
        <span className="requirement-text">
          Al menos 1 carácter especial ({SPECIAL_CHARS_LIST})
        </span>
      </li>
      <li className={`requirement-item ${requirements.hasUpperCase ? 'met' : 'unmet'}`}>
        <span className="requirement-icon">{requirements.hasUpperCase ? '✓' : '○'}</span>
        <span className="requirement-text">Al menos 1 letra mayúscula</span>
      </li>
      <li className={`requirement-item ${requirements.hasLowerCase ? 'met' : 'unmet'}`}>
        <span className="requirement-icon">{requirements.hasLowerCase ? '✓' : '○'}</span>
        <span className="requirement-text">Al menos 1 letra minúscula</span>
      </li>
      <li className={`requirement-item ${requirements.hasMinLength ? 'met' : 'unmet'}`}>
        <span className="requirement-icon">{requirements.hasMinLength ? '✓' : '○'}</span>
        <span className="requirement-text">Al menos 8 caracteres</span>
      </li>
      {showMatchRequirement && (
        <li className={`requirement-item ${passwordsMatch ? 'met' : 'unmet'}`}>
          <span className="requirement-icon">{passwordsMatch ? '✓' : '○'}</span>
          <span className="requirement-text">Las contraseñas coinciden</span>
        </li>
      )}
    </ul>
  );
};

export default PasswordRequirementsComponent;
